import Intercom from "@intercom/messenger-js-sdk"
import { HmacSHA256 } from "crypto-js"
import { useEffect, useRef } from "react"

import { runtimeConfig } from "@costory/front/lib/runtimeConfig"
import { useAuthState } from "@costory/front/queries/auth"

export default function NativeIntercom() {
  const auth = useAuthState()
  const initialized = useRef(false)

  useEffect(() => {
    // Only initialize Intercom when we have a fully loaded, signed-in user
    if (
      !auth.isLoading &&
      auth.isSignedIn &&
      auth.user?.email &&
      auth.user?.currentOrg?.slug &&
      !initialized.current
    ) {
      const userIdentifier = auth.user.email
      const userHash = HmacSHA256(
        userIdentifier,
        runtimeConfig.VITE_INTERCOM_SECRET,
      ).toString()

      Intercom({
        app_id: runtimeConfig.VITE_INTERCOM_WORKSPACE_ID,
        user_id: auth.user.email,
        name: `${auth.user.firstName} ${auth.user.lastName}`,
        email: auth.user.email,
        company: {
          company_id: auth.user.currentOrg.slug,
          name: auth.user.currentOrg.slug,
        },
        userHash,
      })

      initialized.current = true
    }
  }, [auth.isLoading, auth.isSignedIn, auth.user])

  return null
}
